// extracted by mini-css-extract-plugin
export default {"home":"styles_home__VEuAv","mapBackground":"styles_mapBackground__6agvJ","element":"styles_element__17zeS","style":"styles_style__LcZHt"};